import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDXvJ2ZMjxUHx9Jk-1AsAS5-2bVH8_RPs0",
  authDomain: "web-mexico-cocless.firebaseapp.com",
  projectId: "web-mexico-cocless",
  storageBucket: "web-mexico-cocless.firebasestorage.app",
  messagingSenderId: "105033509598",
  appId: "1:105033509598:web:095758138bee86487ab04f",
  measurementId: "G-2DP4RD2TEF"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
